import { apiClient } from './client';

interface PaginatedResponse<T> {
  data: T[];
  meta: { total: number; page: number; limit: number; totalPages: number };
}

export const messagesApi = {
  // ── Admin: Announcements ──

  createAnnouncement: (
    data: {
      recipientIds?: string[];
      recipientRoles?: string[];
      title: string;
      content: Record<string, unknown>;
      priority?: string;
      status?: string;
    },
  ) =>
    apiClient.post<any>('/messages/announcements', data),

  updateAnnouncement: (
    id: string,
    data: Partial<{
      title: string;
      content: Record<string, unknown>;
      priority: string;
      recipientIds: string[];
      recipientRoles: string[];
    }>,
  ) => apiClient.put<any>(`/messages/announcements/${id}`, data),

  publishAnnouncement: (id: string) =>
    apiClient.post<any>(`/messages/announcements/${id}/publish`, {}),

  listAnnouncements: (params?: { page?: number; limit?: number; status?: string }) => {
    const query = new URLSearchParams();
    if (params?.page) query.set('page', String(params.page));
    if (params?.limit) query.set('limit', String(params.limit));
    if (params?.status) query.set('status', params.status);
    return apiClient.get<PaginatedResponse<any>>(
      `/messages/announcements?${query.toString()}`,
    );
  },

  deleteAnnouncement: (id: string) =>
    apiClient.delete(`/messages/announcements/${id}`),

  // ── Admin: Direct Messages ──

  sendDirectMessage: (
    data: {
      recipientIds?: string[];
      recipientRoles?: string[];
      title: string;
      content: Record<string, unknown>;
      priority?: string;
    },
  ) => apiClient.post<any>('/messages/direct', data),

  listDirectMessages: (params?: { page?: number; limit?: number }) => {
    const query = new URLSearchParams();
    if (params?.page) query.set('page', String(params.page));
    if (params?.limit) query.set('limit', String(params.limit));
    return apiClient.get<PaginatedResponse<any>>(
      `/messages/direct?${query.toString()}`,
    );
  },

  getDirectMessageDetail: (id: string) =>
    apiClient.get<any>(`/messages/direct/${id}`),

  // ── User endpoints ──

  getInbox: (params?: {
    page?: number;
    limit?: number;
    type?: string;
    unreadOnly?: boolean;
  }) => {
    const query = new URLSearchParams();
    if (params?.page) query.set('page', String(params.page));
    if (params?.limit) query.set('limit', String(params.limit));
    if (params?.type) query.set('type', params.type);
    if (params?.unreadOnly) query.set('unreadOnly', 'true');
    return apiClient.get<PaginatedResponse<any>>(
      `/messages/inbox?${query.toString()}`,
    );
  },

  getUnreadCount: () =>
    apiClient.get<{ total: number; announcements: number; direct: number }>('/messages/unread-count'),

  markAsRead: (conversationId: string) =>
    apiClient.post<any>(`/messages/${conversationId}/read`, {}),

  reply: (conversationId: string, content: Record<string, unknown>) =>
    apiClient.post<any>(`/messages/${conversationId}/reply`, { content }),

  getConversationDetail: (conversationId: string) =>
    apiClient.get<any>(`/messages/${conversationId}`),
};
